import { render, staticRenderFns } from "./BasketButton.vue?vue&type=template&id=89fec402&scoped=true&"
import script from "./BasketButton.vue?vue&type=script&lang=js&"
export * from "./BasketButton.vue?vue&type=script&lang=js&"
import style0 from "./BasketButton.vue?vue&type=style&index=0&id=89fec402&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fec402",
  null
  
)

export default component.exports